import React, {useState, useEffect, useRef} from 'react';
import axios from 'axios';
import '../config.js';
import { theme, createFormData } from '../services/helper.js';
import { alertService } from '../services/alert.service.js';
import Progress from '../components/progress.js';
import ReceiptListItem from './receiptListItem.js';
import RefundListItem from './refundListItem.js';
import CreditListItem from './creditListItem.js';
import ProformaListItem from './proformaListItem.js';

function InvoiceBasicInfo(props){
  const [loading, setLoading] = useState(false);
  const [description, setDescription] = useState(props.invoice.description);
  const [rate, setRate] = useState(props.invoice.rate);
  const [pax, setPax] = useState(props.invoice.pax);
  const [tax, setTax] = useState(props.invoice.tax);
  const [currency, setCurrency] = useState(props.invoice.currency);
  const [notifySms, setNotifySms] = useState(0);
  const [notifyMail, setNotifyMail] = useState(0);
  
  const handleSubmit = (event) => {
    event.preventDefault();
    if(rate && rate > 0 && pax && pax > 0 && description){
      setLoading(true);
      axios.post(global.config.api_server+'invoice',createFormData({
        description: description,
        rate: rate,
        pax: pax,
        tax: tax,
        currency: currency,
        token: localStorage.getItem("token"),
        id: props.id,
        task: 'edit',
        notifySms: notifySms,
        notifyMail: notifyMail
      })).then(res => {
        setLoading(false);
        if(res.status === 200 && res.data.status === 'success'){
          alertService.success('Invoice updated');
        }else{
          alertService.error(res.data.error);
        }
      }).catch(err => {
        alertService.error(err);
        setLoading(false);
      });
    }else{
      alertService.error('Some fields are required');
    }
  }

  const handleNotifySms = (event) =>{
    if(event.target.checked){
      setNotifySms(1);
    }else{
      setNotifySms(0);
    }
  }

  const handleNotifyMail = (event) =>{
    if(event.target.checked){
      setNotifyMail(1);
    }else{
      setNotifyMail(0);
    }
  }

  const balance = parseFloat(props.invoice.amount) - parseFloat(props.invoice.paid);

  return(
    <div>
      <div className="card shadow mb-4">
        <div className="card-header py-3">
          <button onClick={(e) => handleSubmit(e)} className={'btn btn-icon-split float-right btn-'+theme()}>
            <span className="icon text-white-50">
              <i className="fas fa-save"></i>
            </span>
            <span className="text">Save</span>
          </button>
          <h6 className={'mt-2 font-weight-bold text-'+theme()}>Tax Invoice Detail</h6>
        </div>
        <div className="card-body">
          <div className="row">
            {loading === true ? (
              <Progress label='Saving' small={true}/>
            ):null}
            <div className="col-md-6">
              <div className="form-group">
                <label>Tax Invoice id</label>
                <input type="text" value={props.invoice.invoice_id} disabled={true} className="form-control"/>
              </div>
              <div className="form-group">
                <label>Total amount</label>
                <input type="text" value={props.invoice.amount} disabled={true} className="form-control"/>
              </div>
              <div className="form-group">
                <label>Amount paid</label>
                <input type="text" value={props.invoice.paid} disabled={true} className="form-control"/>
              </div>
              <div className="form-group">
                <label>Balance</label>
                <input type="text" value={balance} disabled={true} className="form-control"/>
              </div>
              <div className="form-group">
                <input type="checkbox" onChange={(e) => handleNotifyMail(e)}/> Send Mail &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<input type="checkbox" onChange={(e) => handleNotifySms(e)}/> Send SMS
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label>Currency *</label>
                <select value={currency} name="currency" className="form-control" id="currency" onChange={(e) => setCurrency(e.target.value)}>
                  {global.config.currencies.split(",").map(c =>
                    <option value={c} key={c}>{c}</option>
                  )}
                </select>
              </div>
              <div className="form-group">
                <label>Number of Pax *</label>
                <input type="number" value={pax} name="pax" className="form-control" id="pax" placeholder="Enter pax" onChange={(e) => setPax(e.target.value)}/>
              </div>
              <div className="form-group">
                <label>Rate per pax *</label>
                <input type="number" value={rate} name="rate" className="form-control" id="rate" placeholder="Enter Rate" onChange={(e) => setRate(e.target.value)}/>
              </div>
              <div className="form-group">
                <label>Services *</label>
                <textarea className="form-control textarea-xlg" value={description} onChange={(e)=>setDescription(e.target.value)}></textarea>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <hr/>
              <div className="form-group">
                <label><strong>Stats</strong></label>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label>Updated</label>
                <input type="text" disabled={true} value={props.invoice.updation_date} className="form-control"/>
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label>Created</label>
                <input type="text" disabled={true} value={props.invoice.creation_date} className="form-control"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card shadow mb-4">
        <div className="card-header py-3">
          <h6 className={'mt-2 font-weight-bold text-'+theme()}>Proforma Invoice</h6>
        </div>
        <div className="card-body">
        <div className="table-responsive">
          <div className="row">
            {loading === true ? (
              <Progress label='Loading..' small={true}/>
            ):null}
              <div className="col-sm-12">
                <table className="table table-bordered" width="100%">
                  <thead>
                    <tr>
                      <th>Proforma Invoice Id</th>
                      <th>Description</th>
                      <th>Pax</th>
                      <th>Currency</th>
                      <th>Total Amount</th>
                      <th>Updated On</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ProformaListItem info={props.invoice.proforma} type="client"/>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card shadow mb-4">
        <div className="card-header py-3">
          <h6 className={'mt-2 font-weight-bold text-'+theme()}>Receipts</h6>
        </div>
        <div className="card-body">
        <div className="table-responsive">
          <div className="row">
            {loading === true ? (
              <Progress label='Loading..' small={true}/>
            ):null}
              <div className="col-sm-12">
                <table className="table table-bordered" width="100%">
                  <thead>
                    <tr>
                      <th>Receipt Id</th> 
                      <th>Additional Note</th>
                      <th>Payment Mode</th>
                      <th>Amount</th>
                      <th>Currency</th>
                      <th>Created On</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {props.invoice.receipts.map(receipt =>
                      <ReceiptListItem info={receipt} key={receipt.receipt_id} type="client"/>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card shadow mb-4">
        <div className="card-header py-3">
          <h6 className={'mt-2 font-weight-bold text-'+theme()}>Refund Receipts</h6>
        </div>
        <div className="card-body">
        <div className="table-responsive">
          <div className="row">
            {loading === true ? (
              <Progress label='Loading..' small={true}/>
            ):null}
              <div className="col-sm-12">
                <table className="table table-bordered" width="100%">
                  <thead>
                    <tr>
                      <th>Refund Receipt Id</th> 
                      <th>Additional Note</th>
                      <th>Amount</th>
                      <th>Currency</th>
                      <th>Created On</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {props.invoice.refunds.map(refund =>
                      <RefundListItem info={refund} key={refund.refund_id} type="client"/>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card shadow mb-4">
        <div className="card-header py-3">
          <h6 className={'mt-2 font-weight-bold text-'+theme()}>Credit Notes</h6>
        </div>
        <div className="card-body">
        <div className="table-responsive">
          <div className="row">
            {loading === true ? (
              <Progress label='Loading..' small={true}/>
            ):null}
              <div className="col-sm-12">
                <table className="table table-bordered" width="100%">
                  <thead>
                    <tr>
                      <th>Credit Note Id</th> 
                      <th>Additional Note</th>
                      <th>Status</th>
                      <th>Amount</th>
                      <th>Currency</th>
                      <th>Created On</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {props.invoice.credits.map(credit =>
                      <CreditListItem info={credit} key={credit.credit_id} type="client"/>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default InvoiceBasicInfo;